module.exports = __webpack_public_path__ + "assets/images/rbyearend-16-desktop.jpg?v=2f02be30";